import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "customSize", "hasBorder", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import FlagBorder from '@bubble-ui/atom-flag-border';
import { SHOW_DEPRECATION_WARNINGS } from '@bubble-dev/build-config';
var SIZE_DEFAULT = 180;
export var FlagWrapper = Target => _ref => {
  var {
      accessibilityLabel,
      customSize,
      hasBorder,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var componentName = Target.displayName;
  var removalDate = 'v7.0.0';
  var useInstead = 'UNSAFE_svgProps';
  var readMore = undefined;
  if (SHOW_DEPRECATION_WARNINGS && props !== undefined) {
    Object.keys(props).forEach(propName => {
      var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: '".concat(propName, "' prop of '").concat(componentName, "' is deprecated because we are deprecating props spreading and will be removed");
      if (removalDate) {
        deprecationWarning += " in/by ".concat(removalDate);
      }
      deprecationWarning += ".";
      if (useInstead) {
        deprecationWarning += "\nUse '".concat(useInstead, "' prop instead to spread this prop.");
      }
      deprecationWarning += "\nPlease reach out to us in #team-design-system-cpo on slack if you think '".concat(propName, "' should be a supported prop of '").concat(componentName, "'.");
      if (readMore) {
        deprecationWarning += "\nRead more on ".concat(readMore);
      }
      console.warn(deprecationWarning);
    });
  }
  var size = customSize || SIZE_DEFAULT;
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, props), /*#__PURE__*/React.createElement(Target, null), hasBorder && /*#__PURE__*/React.createElement(FlagBorder, null));
};
//# sourceMappingURL=FlagWrapper.js.map